<template>
  <div class="container">
    Need a form here for the question<br/>
    Need to list the choices<br/>
    Need to be able to select the correct choice<br/>
    Need a submit button<br/>
    <form>
<p>
        <label for="question">Question</label>
        <input class="form-control" id="question" v-model="question.text" placeholder="Question Text">
      </p><h3>Choices</h3>
        <input class="form-control" id="choiceA" v-model="question.choice" placeholder="A">
        <input class="form-control" id="choiceB" v-model="question.choice" placeholder="B">
        <input class="form-control" id="choiceC" v-model="question.text" placeholder="C">
        <input class="form-control" id="choiceD" v-model="question.text" placeholder="D">

    </form>
  </div>
</template>

<script>
export default {
  name: 'CreateLive',
  props: {
    msg: String
  },
  data(){
      return{
          question: {
              text: "",
              choices: [
                  {

                  }
              ]
          }
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
